import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import { ApiService } from 'app/core/service/core/api.service';
import swal from 'sweetalert2';
import { empty } from 'rxjs/Observer';

@Component({
  selector: 'app-commerce-sat-form',
  templateUrl: './commerce-sat-form.component.html'//,
  //styleUrls: ['./commerce-appointment-form.component.scss']
})

export class CommerceSatFormComponent extends FormBaseComponent<any> implements OnInit {
    ngOnInit() {
        this.init(true);
    }

    constructor(private apiService: ApiService) {
        super();
    }

    template() {
        this.form.addControl('usuario', new FormControl(''));
        this.form.addControl('contrasena', new FormControl(''));
        this.form.addControl('contrasenaB', new FormControl(''));
        this.form.addControl('validacion', new FormControl(''));
        this.form.addControl('terminos', new FormControl(''));
    }

    ValidaSat()
    {    
        if(this.form.controls.contrasena.value == this.form.controls.contrasenaB.value)
        {
            this.apiService.sendSat(
                "login",
                {
                    user: this.form.controls.usuario.value,
                    password : this.form.controls.contrasena.value
                },
                "post").then(result => {
                    if(result != empty){
                        if(result.success == true){
                            swal({
                                type: 'success',
                                title: 'Proceso correcto'
                              });
                        }
                        else{
                            swal({
                                type: 'error',
                                title: 'Disculpe las molestias',
                                text: result.message,
                              });
                        }
                    }
                    else{
                        swal({
                            type: 'error',
                            title: 'Disculpe las molestias',
                            text: 'Los Servicios no se encuentran disponibles',
                          });
                    }
                });
        }
        else{
            
        }

    }
}




// WEBPACK FOOTER //
// ./src/app/form/form/commerce-sat-form/commerce-sat-form.component.ts